"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthenticated = void 0;
var _react = require("react");
var _redirectService = require("./redirectService");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var redirectTo = _redirectService.redirectService.redirectTo;
var configureTimeZone = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var _user$profile;
    var user, refetchUser, preferredTimeZone, profileUrl;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            user = _ref.user, refetchUser = _ref.refetchUser;
            preferredTimeZone = ((_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.timeZone) || _momentTimezone.default.tz.guess(); // Store user's time zone if we don't have one for them
            if (!(user.profile && !user.profile.timeZone && !user.isSimulationMode)) {
              _context.next = 7;
              break;
            }
            profileUrl = (0, _utils.isPatient)(user) ? (0, _utils.getPatientProfileUrl)() : (0, _utils.isClinician)(user) ? (0, _utils.getClinicianProfileUrl)('me') : (0, _utils.getAdminProfileUrl)('me');
            _context.next = 6;
            return _utils.apiWithoutErrorsHandler.patch(profileUrl, {
              timeZone: preferredTimeZone
            });
          case 6:
            refetchUser();
          case 7:
            // Set default timezone, already stored in identity profile or take local if empty
            _momentTimezone.default.tz.setDefault(preferredTimeZone);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function configureTimeZone(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var useAuthenticated = function useAuthenticated(_ref3) {
  var identity = _ref3.identity,
    refetchUser = _ref3.refetchUser;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAuthenticated = _useState2[0],
    setIsAuthenticated = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    user = _useState4[0],
    setUser = _useState4[1];
  (0, _react.useEffect)(function () {
    if (identity) {
      configureTimeZone({
        user: identity,
        refetchUser: refetchUser
      });

      // this redirects user to correct application depending on 'resource' and prevents errors when
      // for instance user logged as clinician is trying to navigate to patient's app
      // please do not use matchPath from `react-router-dom` because match is incorrect
      // in case there is hash or query in href
      if (_utils.isAppOnEnv) {
        var targetResource = (0, _utils.stripTrailingSlash)(identity.resource);
        if (!window.location.href.includes(targetResource)) {
          redirectTo(targetResource);
          return;
        }
      }
      setUser(identity);
      setIsAuthenticated(!!(identity !== null && identity !== void 0 && identity.accountId) || (0, _utils.isAdmin)(identity));
    }
  }, [identity]);
  return {
    user: user,
    isAuthenticated: isAuthenticated
  };
};
exports.useAuthenticated = useAuthenticated;